import { createFileRoute } from '@tanstack/react-router'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'
import { QuotationDetailPage } from '../../../../features/sales/quotation-pages'

export const Route = createFileRoute('/_app/quotations/$quotationId/')({
  validateSearch: documentActionSearchSchema,
  component: QuotationDetailPage,
})
